import { render, staticRenderFns } from "./DestinosToneladasHistorico.vue?vue&type=template&id=c881cec4"
import script from "./DestinosToneladasHistorico.vue?vue&type=script&lang=js"
export * from "./DestinosToneladasHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports